import { useCache } from '@/helpers/cache'

export default async function usePreload(src)
{
    const cache = useCache()
    if ( !cache.has(src) )
    {
        const response = await fetch(src)
        if ( !response.ok ) {
            throw new TypeError("Bad response status");
        }

        const blob = await response.blob();
        cache.set(src, blob);
    }

    return cache.get(src)
}